'use client';

import { c as _c } from "react/compiler-runtime";
import Button from '@eversports/klimt-primitives/Button';
import { Input } from '@eversports/klimt-primitives/Input';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { useFormState } from '../../../../../hooks/useFormState';
import Processing from '../../../../../patterns/Processing';
import { validateRedirectUrl } from '../../../../../utils/validate-redirect-url';
import { loginAction } from './action';
import type { LoginErrorTranslation } from './schema';
interface Props {
  url?: string;
}
export function LoginForm(t0) {
  const $ = _c(44);
  const {
    url
  } = t0;
  const translate = useTranslations("authentication");
  const [isRedirecting, setIsRedirecting] = useState(false);
  const {
    state,
    formAction,
    isPending,
    message,
    success,
    getFieldError,
    getFieldValue
  } = useFormState(loginAction);
  const emailError = getFieldError("email");
  const passwordError = getFieldError("password");
  let t1;
  if ($[0] !== state?.data?.to || $[1] !== success || $[2] !== url) {
    t1 = () => {
      if (!success) {
        return;
      }
      sessionStorage.clear();
      localStorage.clear();
      setIsRedirecting(true);
      window.location.replace(state?.data?.to ?? validateRedirectUrl(url));
    };
    $[0] = state?.data?.to;
    $[1] = success;
    $[2] = url;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== success) {
    t2 = [success];
    $[4] = success;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  const t3 = "login-form";
  const t4 = "flex w-full flex-col gap-2";
  let t5;
  if ($[6] !== url) {
    t5 = url && <input type="hidden" name="url" value={url} />;
    $[6] = url;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = emailError ? translate(emailError as LoginErrorTranslation) : undefined;
  let t7;
  if ($[8] !== translate) {
    t7 = translate("email-placeholder");
    $[8] = translate;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== getFieldValue) {
    t8 = getFieldValue("email");
    $[10] = getFieldValue;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = <Input id="email" name="email" type="email" error={t6} placeholder={t7} defaultValue={t8} required={true} />;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const T0 = Input;
  const t10 = "password";
  const t11 = "password";
  const t12 = passwordError ? translate(passwordError as LoginErrorTranslation) : undefined;
  let t13;
  if ($[16] !== translate) {
    t13 = translate("password-placeholder");
    $[16] = translate;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== getFieldValue) {
    t14 = getFieldValue("password");
    $[18] = getFieldValue;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== T0 || $[21] !== t12 || $[22] !== t13 || $[23] !== t14) {
    t15 = <T0 name={t10} type={t11} error={t12} placeholder={t13} defaultValue={t14} required={true} />;
    $[20] = T0;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== message || $[26] !== success || $[27] !== translate) {
    t16 = message && !success && <div data-testid="auth-error" className="rounded-md border border-border-error p-1 text-sm text-text-error">{translate(message as LoginErrorTranslation)}</div>;
    $[25] = message;
    $[26] = success;
    $[27] = translate;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const t17 = isPending || isRedirecting;
  const t18 = isPending || isRedirecting;
  let t19;
  if ($[29] !== translate) {
    t19 = translate("login-button");
    $[29] = translate;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t18 || $[32] !== t19) {
    t20 = <Button type="submit" disabled={t18} className="w-full">{t19}</Button>;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t17 || $[35] !== t20) {
    t21 = <Processing isLoading={t17} size="size-2" className="w-full">{t20}</Processing>;
    $[34] = t17;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== formAction || $[38] !== t15 || $[39] !== t16 || $[40] !== t21 || $[41] !== t5 || $[42] !== t9) {
    t22 = <form id={t3} action={formAction} className={t4}>{t5}{t9}{t15}{t16}{t21}</form>;
    $[37] = formAction;
    $[38] = t15;
    $[39] = t16;
    $[40] = t21;
    $[41] = t5;
    $[42] = t9;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  return t22;
}